// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  width: 90%;
  display: flex;
  flex-direction: column;
}

.visitForm_select_wrap__M5KNB {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.visitForm_select_wrap__M5KNB label {
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 5px;
}
.visitForm_select_wrap__M5KNB select {
  height: 50px;
  width: 100%;
  padding: 13px 18px;
  padding-right: 25px;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
}

.visitForm_date_wrap__j-NRP {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.visitForm_date_wrap__j-NRP label {
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 5px;
}
.visitForm_date_wrap__j-NRP .datepicker_field {
  height: 50px;
  width: 25%;
  min-width: 175px;
  padding: 13px 15px;
  padding-right: 25px;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  background-color: #ffffff;
}

.visitForm_form_button__NHIqA {
  width: fit-content;
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  border-radius: 16px;
  padding: 12px 33px;
  margin: 0 auto;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: white;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}
.visitForm_form_button__NHIqA:hover {
  background: var(--green-light);
  border: 2px solid var(--green-light);
  transform: scale(1.02);
  color: #2e706c;
  transition: all 0.3s;
}
.visitForm_form_button__NHIqA:disabled {
  background-color: var(--border-default-color);
  border: 2px solid var(--border-default-color);
  color: var(--gray-text-color);
  transform: scale(1);
  cursor: default;
}
@media (max-width: 991px) {
  .visitForm_form_button__NHIqA {
    font-size: 12px;
    padding: 10px 10px;
  }
}

.error {
  color: red;
  font-size: 14px;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Forms/VisitForm/visitForm.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;AACE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AACE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAF;AAEE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,YAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AADJ;;AAKA;EACE,kBAAA;EACA,wCAAA;EACA,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;AAFF;AAIE;EACE,8BAAA;EACA,oCAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;AAFJ;AAKE;EACE,6CAAA;EACA,6CAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;AAHJ;AAME;EA/BF;IAgCI,eAAA;IACA,kBAAA;EAHF;AACF;;AAMA;EACE,UAAA;EACA,eAAA;EACA,cAAA;AAHF","sourcesContent":["form {\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n}\n\n.select_wrap {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n\n  label {\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 700;\n    margin-bottom: 5px;\n  }\n  select {\n    height: 50px;\n    width: 100%;\n    padding: 13px 18px;\n    padding-right: 25px;\n    border: none;\n    outline: none;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 1;\n  }\n}\n\n.date_wrap {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n\n  label {\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 700;\n    margin-bottom: 5px;\n  }\n\n  :global(.datepicker_field) {\n    height: 50px;\n    width: 25%;\n    min-width: 175px;\n    padding: 13px 15px;\n    padding-right: 25px;\n    border: none;\n    outline: none;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 1;\n    background-color: #ffffff;\n  }\n}\n\n.form_button {\n  width: fit-content;\n  background-color: var(--secondary-color);\n  border: 2px solid var(--secondary-color);\n  border-radius: 16px;\n  padding: 12px 33px;\n  margin: 0 auto;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: white;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  &:hover {\n    background: var(--green-light);\n    border: 2px solid var(--green-light);\n    transform: scale(1.02);\n    color: #2e706c;\n    transition: all 0.3s;\n  }\n\n  &:disabled {\n    background-color: var(--border-default-color);\n    border: 2px solid var(--border-default-color);\n    color: var(--gray-text-color);\n    transform: scale(1);\n    cursor: default;\n  }\n\n  @media (max-width: 991px) {\n    font-size: 12px;\n    padding: 10px 10px;\n  }\n}\n\n:global(.error) {\n  color: red;\n  font-size: 14px;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select_wrap": `visitForm_select_wrap__M5KNB`,
	"date_wrap": `visitForm_date_wrap__j-NRP`,
	"form_button": `visitForm_form_button__NHIqA`
};
export default ___CSS_LOADER_EXPORT___;
